import { render, staticRenderFns } from "./SliceParagraphWithVisual.vue?vue&type=template&id=3386c7fd&scoped=true"
import script from "./SliceParagraphWithVisual.vue?vue&type=script&lang=js"
export * from "./SliceParagraphWithVisual.vue?vue&type=script&lang=js"
import style0 from "./SliceParagraphWithVisual.vue?vue&type=style&index=0&id=3386c7fd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3386c7fd",
  null
  
)

export default component.exports